import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IMemberSearchFilters } from 'app/cd/services/member-service';
import { NamespaceOptions } from 'app/shared/lib/i18n';


@autoinject()
export class MemberSearchCriteriaCustomElement extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.object({ defaultBindingMode: bindingMode.twoWay })
    public memberSearchFilters: IMemberSearchFilters = {};

    @bindable.string()
    public i18nNamespace: Extract<NamespaceOptions, NamespaceOptions.CD | NamespaceOptions.PP> = NamespaceOptions.CD;

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }



    ////****************** Events ***************************************************////



    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////

}
